<div class="dropdown relative">
  <p class="absolute z-10 text-white-disabled text-xs -top-5" *ngIf="label">{{label}}</p>
  <input [id]="componentId + '-input'" [attr.data-cy]="componentId + '-input'"
    class="bg-white hover:bg-white-hoverGrey text-sm px-4 py-3 rounded w-full outline-none border border-white-900"
    [ngClass]="{'disabled':control.disabled}" [placeholder]="placeholder" [formControl]="control">
</div>
